import InviteAppliedBanner from './InviteAppliedBanner'

export default InviteAppliedBanner
